import { createDeferred } from "@/helpers/functions/createDeferred";
import { noop } from "@vueuse/core";

/**
 * @param {import("vue").Ref<import("vue").ComponentPublicInstance>} prompt
 * @returns {{ result: () => Promise<boolean>, open: () => void, close: () => void }}
 */
export function usePrompt(prompt) {
  let _promise = noop();

  function open() {
    const { promise, resolve } = createDeferred();
    prompt.value.open(resolve);
    _promise = promise;
  }

  function close() {
    prompt.value.close();
  }

  function result() {
    return _promise;
  }

  return {
    result,
    open,
    close,
  };
}
